var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.apaPostBy)?_c('Article',{attrs:{"post":_vm.apaPostBy,"is-free":_vm.apaPostBy.free,"role":"main"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }